import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import AboutOdonata from './pages/AboutOdonata';
import AboutMe from './pages/AboutMe';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/about-odonata" element={<AboutOdonata />} />
            <Route path="/about-me" element={<AboutMe />} />
          </Routes>
        </main>
        <footer className="site-footer">
          <div className="container">
            <p>© 2026 Odonata Boy • Powered by iNaturalist API</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
